import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/es/storage';
import { reducer as notificationsReducer } from 'react-notification-system-redux';

import addressReducer from 'app/ducks/addresses/reducer';
import authenticationReducer from 'app/ducks/authentication/reducer';
import bankAccountReducer from 'app/ducks/bankAccounts/reducer';
import bulkMatchPaymentsReducer from 'app/ducks/bulkMatchPayments/reducer';
import cartReducer from 'app/ducks/cart/reducer';
import clubsReducer from 'app/ducks/clubs/reducer';
import competitionsReducer from 'app/ducks/competitions/reducer';
import connectReducer from 'app/ducks/connect/reducer';
import creditCardsReducer from 'app/ducks/creditCards/reducer';
import dashboardReducer from 'app/ducks/dashboard/reducer';
import forfeitsReducer from 'app/ducks/forfeits/reducer';
import globalReducer from 'app/ducks/global/reducer';
import groupsReducer from 'app/ducks/groups/reducer';
import invitationsReducer from 'app/ducks/invitations/reducer';
import loadingReducer from 'app/ducks/loading/reducer';
import matchPaymentsReducer from 'app/ducks/matchPayments/reducer';
import onBoardingReducer from 'app/ducks/onboarding/reducer';
import organisationSectionsReducer from 'app/ducks/organisationSections/reducer';
import organisationsReducer from 'app/ducks/organisations/reducer';
import paymentCollectionsReducer from 'app/ducks/paymentCollections/reducer';
import paymentEventsReducer from 'app/ducks/paymentEvents/reducer';
import paymentsReducer from 'app/ducks/payments/reducer';
import payoutLineItemsReducer from 'app/ducks/payoutLineItems/reducer';
import payoutsReducer from 'app/ducks/payouts/reducer';
import purchasesReducer from 'app/ducks/purchases/reducer';
import receiptsReducer from 'app/ducks/receipts/reducer';
import remindersReducer from 'app/ducks/reminders/reducer';
import reportsReducer from 'app/ducks/reports/reducer';
import seasonsReducer from 'app/ducks/seasons/reducer';
import teamConnectionsReducer from 'app/ducks/teamConnections/reducer';
import teamMembersReducer from 'app/ducks/teamMembers/reducer';
import teamPaymentCollectionsReducer from 'app/ducks/teamPaymentCollections/reducer';
import teamPaymentRequestMetricsReducer from 'app/ducks/teamPaymentRequestMetrics/reducer';
import dashboardTeamPaymentRequestsReducer from 'app/ducks/dashboardTeamPaymentRequests/reducer';
import teamPaymentRequestsReducer from 'app/ducks/teamPaymentRequests/reducer';
import teamsReducer from 'app/ducks/teams/reducer';
import userReducer from 'app/ducks/users/reducer';
import teamMemberSummariesReducer from 'app/ducks/teamMemberSummaries/reducer';
import bulkImportsReducer from 'app/ducks/bulkImports/reducer';

import { AuthenticationActionTypes } from 'app/ducks/authentication/types';

const config = {
  key: 'primary',
  storage,
  whitelist: ['authentication', 'onBoarding', 'dashboard'],
};

const appReducer = persistReducer(
  config,
  combineReducers({
    addresses: addressReducer,
    authentication: authenticationReducer,
    bankAccounts: bankAccountReducer,
    bulkMatchPayments: bulkMatchPaymentsReducer,
    cart: cartReducer,
    clubs: clubsReducer,
    competitions: competitionsReducer,
    connect: connectReducer,
    creditCards: creditCardsReducer,
    dashboard: dashboardReducer,
    forfeits: forfeitsReducer,
    global: globalReducer,
    groups: groupsReducer,
    invitations: invitationsReducer,
    loading: loadingReducer,
    matchPayments: matchPaymentsReducer,
    notifications: notificationsReducer,
    onBoarding: onBoardingReducer,
    organisations: organisationsReducer,
    organisationSections: organisationSectionsReducer,
    paymentCollections: paymentCollectionsReducer,
    paymentEvents: paymentEventsReducer,
    payments: paymentsReducer,
    payoutLineItems: payoutLineItemsReducer,
    payouts: payoutsReducer,
    purchases: purchasesReducer,
    receipts: receiptsReducer,
    reminders: remindersReducer,
    reports: reportsReducer,
    seasons: seasonsReducer,
    teamConnections: teamConnectionsReducer,
    teamMembers: teamMembersReducer,
    teamPaymentCollections: teamPaymentCollectionsReducer,
    teamPaymentRequestMetrics: teamPaymentRequestMetricsReducer,
    dashboardTeamPaymentRequests: dashboardTeamPaymentRequestsReducer,
    teamPaymentRequests: teamPaymentRequestsReducer,
    teams: teamsReducer,
    users: userReducer,
    teamMemberSummaries: teamMemberSummariesReducer,
    bulkImports: bulkImportsReducer,
  }),
);

export default (state, action) => {
  if (action.type === AuthenticationActionTypes.USER_LOGOUT) {
    state = undefined; // eslint-disable-line no-param-reassign
    storage.removeItem('persist:primary').then(() => {});
  }
  // if(action.type === 'persist/REHYDRATE') {  state = action.payload  }

  return appReducer(state, action);
};
